export default {
  forms: {
    data: [],
    meta: {}
  },
  form: null,
  steps: [],
  fields: [],
  fieldTypes: [],
  fieldTypesGrouped: {},
  selectedField: null,
  selectedStep: null,
  isDirty: false,
  isLoading: false
}
